import {Divider, Flex, Text} from '@mantine/core';
import type {FC} from 'react';
import {Description} from 'src/design/atoms/Description';
import {SecondaryPanel} from 'src/design/atoms/SecondaryPanel';

/**
 * Titled secondary panel with an optional description, a divider, and a
 * responsive row of action children.
 * @registry Secondary-actions panel: title, optional description, divider,
 * responsive action row.
 *
 * Ported from `library/forms/FormSecondaryActionPanel`. Renamed
 * `FormSecondaryActionPanel` -> `SecondaryActionPanel`. Prop surface kept
 * identical.
 */
export interface SecondaryActionPanelProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export const SecondaryActionPanel: FC<SecondaryActionPanelProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <SecondaryPanel>
      <Text>{title ?? 'Secondary Actions'}</Text>
      {description && <Description text={description} />}
      <Divider mb="md" mt="md" />
      <Flex direction={{base: 'column', lg: 'row'}} gap="md">
        {children}
      </Flex>
    </SecondaryPanel>
  );
};
